import { configureStore } from "@reduxjs/toolkit";
import { componentsReducer } from "./componentsSlice";

import rtkApi from "../store/api";
import { commonSlice } from "./commonSlice";
import { authSlice } from "./authSlice";
import satisfactionReducer from './satisfactionSlice';
import projectReducer from "./projectSlice";
import heatModeReducer from "./heatModeSlice";
import coolModeReducer from "./coolModeSlice";


export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    components: componentsReducer,
    common: commonSlice.reducer,
    [rtkApi.reducerPath]: rtkApi.reducer,
    satisfaction: satisfactionReducer,
    project: projectReducer,
    heatMode: heatModeReducer, 
    coolMode: coolModeReducer, 
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(rtkApi.middleware);
  },
  devTools: true,
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
